import { render, staticRenderFns } from "./form.vue?vue&type=template&id=41da654e&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=41da654e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da654e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41da654e')) {
      api.createRecord('41da654e', component.options)
    } else {
      api.reload('41da654e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=41da654e&scoped=true", function () {
      api.rerender('41da654e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/pushConfiguration/cmp/form.vue"
export default component.exports